// src/pages/Frontend.tsx
import styled from 'styled-components';

export default function FrontendDevelopment() {
  return (
    <Container>
      <Title>Frontend Development</Title>
      <Subtitle>
        Crafting pixel-perfect, interactive, and high-performance user interfaces.
      </Subtitle>

      <Content>
        <Section>
          <h3>UI/UX Principles</h3>
          <ul>
            <li>Consistency in design and layout</li>
            <li>Intuitive navigation and user flow</li>
            <li>Clear visual hierarchy</li>
            <li>Accessibility and color contrast</li>
          </ul>
        </Section>

        <Section>
          <h3>Technologies & Tools</h3>
          <TechGrid>
            <TechItem>React</TechItem>
            <TechItem>TypeScript</TechItem>
            <TechItem>Styled Components</TechItem>
            <TechItem>Framer Motion</TechItem>
            <TechItem>Redux / Zustand</TechItem>
            <TechItem>Next.js</TechItem>
          </TechGrid>
        </Section>

        <Section>
          <h3>Performance Tips</h3>
          <p>
            Use code-splitting, image optimization, and lazy loading to keep your
            application fast. Minimize re-renders with memoization and efficient
            state management.
          </p>
        </Section>
      </Content>
    </Container>
  );
}

// Styled Components (same as WebDevelopment)
const Container = styled.div`
  padding: 4rem 2rem;
  color: ${({ theme }) => theme.text};
`;

const Title = styled.h1`
  font-size: 2.8rem;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  margin-bottom: 3rem;
  color: ${({ theme }) => theme.text};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

const Section = styled.div`
  h3 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.primary};
  }
  ul {
    list-style: disc;
    padding-left: 1.5rem;
  }
`;

const TechGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 1rem;
`;

const TechItem = styled.div`
  background: rgba(255, 255, 255, 0.08);
  padding: 0.8rem;
  border-radius: 0.5rem;
  text-align: center;
  font-weight: bold;
  box-shadow: ${({ theme }) => theme.buttonShadow};
`;
